import {rootState} from '@mintdata-wsp/common/state/RootState';
import {FullScreenState} from '@mintdata-wsp/common/state/ui/visualDesigner/workbench/WorkbenchState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {WindowUtil} from '@mintdata-wsp/wsp/util/WindowUtil';
import {action} from 'mobx';

//
// Based on:
// https://developers.google.com/web/updates/2011/10/Let-Your-Content-Do-the-Talking-Fullscreen-API
//

export class FullScreenController
{
    init():void
    {
        WindowUtil.addFullScreenChangeListener(this._onFullScreenChanged);
    }

    @action.bound
    private _onFullScreenChanged(e:any):void
    {
        this._updateFullScreenState();
        // this._getState().isFullScreen = !this._getState().isFullScreen;
    }

    @action.bound
    public setPageDomElement(ref:HTMLElement):void
    {
        this._getState().pageDomElement = ref;
    }

    public isFullScreen():boolean
    {
        return this._getState().isFullScreen;
    }

    @action.bound
    public enterFullScreen():void
    {
        const state = this._getState();
        if( state.isFullScreen )
            return;

        controllers.ui.workbench.closeAllContextMenus();

        const pageDomElement = state.pageDomElement;
        if( pageDomElement )
        {
            // this._updateFullScreenState();
            const elem = (pageDomElement as any);

            if( elem.webkitRequestFullscreen )
                elem.webkitRequestFullscreen((Element as any).ALLOW_KEYBOARD_INPUT);

            if( elem.mozRequestFullScreen )
                elem.mozRequestFullScreen();

            if( elem.msRequestFullscreen )
                elem.msRequestFullscreen();

            if( elem.requestFullscreen )
                elem.requestFullscreen(); // standard
        }
    }

    @action.bound
    private _updateFullScreenState():void
    {
        this._getState().isFullScreen = WindowUtil.isFullScreen();
    }

    @action.bound
    public exitFullScreen():void
    {
        const state = this._getState();
        if( !state.isFullScreen )
            return;

        const pageDomElement = state.pageDomElement;
        if( pageDomElement )
        {
            state.isFullScreen = false;
            const elem:any = document;

            if( elem.webkitExitFullscreen )
                elem.webkitExitFullscreen((Element as any).ALLOW_KEYBOARD_INPUT);

            if( elem.mozCancelFullScreen )
                elem.mozCancelFullScreen();

            if( elem.msExitFullscreen )
                elem.msExitFullscreen();

            if( elem.exitFullscreen )
                elem.exitFullscreen(); // standard
        }
    }

    private _getState():FullScreenState
    {
        return rootState.ui.visualDesigner.workbench.fullScreen;
    }
}
